import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailsCardRevamp from "./component";
import { withRouter } from "react-router-dom";
import { updateSelectedOnScreenFilter, updateAppliedFilters, updateAllFiltersVisibility } from "../filters/actions";
import { reloadCarList, resetCarList } from "../make-filter/actions";
import { setLoginType, updateProfile } from "../../au.configuration/actions";
import { createOrder, updateValidC2bOrder, getValidQuotesInHouseFinance, updateBasicHubspot } from "../checkout-info/actions";
import { createTestDriveAvailability } from "../test-drive/wrapper/actions";
import { getOrderDetail, setTestDriveVariant, getOrderDetailSuccess } from "../test-drive-v2/actions";
import { getInhouseEligibility, getInhousePreApprovalLoanDetails } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { setShowHubLocationModal, updateExtendedWarrantySelection } from "../car-details/actions";
import { updateWishlistNote } from "../my-wishlist/actions";
import { startPreApprovalOnFly } from "../pre-approval-on-fly-modal/actions";

const mapStateToProps = ({
    carDetails: {
        content,
        config: {imageHost = ""} = {},
        cmsConfig
    },
    deliveryInfo,
    filters: {
        allFilters,
        selectedFilters
    },
    cities: {
        selectedCity
    },
    carDetails: {
        galleryProps: { isOpen: isGalleryOpen }
    },
    user: {secureToken, isUserZeroDpVariant, isLoggedIn, email: userEmail},
    checkout: {
        order,
        personalDetails,
        order: { orderId}
    },
    tradeIn: {
        tradeInToggleSelected,
        userTradeInData
    },
    abExperiment: {
        webPriceDropDesktop,
        desktopCdpEw,
        cdpCtaReorder,
        preApprovalOnFlyDesktop
    },
    config: {
        testDriveConfig
    },
    myBookings: {
        paymentSummaryData
    },
    videoGallery: {
        isVideoGalleryModalOpen
    },
    cmsConfig: globalCmsConfig
}) => ({
    content,
    deliveryInfo,
    imageHost,
    allFilters,
    selectedFilters,
    selectedCity,
    isGalleryOpen,
    secureToken,
    order,
    tradeInToggleSelected,
    isUserZeroDpVariant,
    isLoggedIn,
    personalDetails,
    orderId,
    webPriceDropDesktop,
    testDriveConfig,
    cmsConfig,
    desktopCdpEw,
    paymentSummaryData,
    isVideoGalleryModalOpen,
    cdpCtaReorder,
    userTradeInData,
    globalCmsConfig,
    preApprovalOnFlyDesktop,
    userEmail
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    reloadCarListConnect: reloadCarList,
    updateAllFiltersVisibilityConnect: updateAllFiltersVisibility,
    resetCarListConnect: resetCarList,
    updateAppliedFiltersConnect: updateAppliedFilters,
    setLoginTypeConnect: setLoginType,
    createOrderConnect: createOrder,
    createTestDriveAvailabilityConnect: createTestDriveAvailability,
    updateProfileConnect: updateProfile,
    getOrderDetailConnect: getOrderDetail,
    updateValidC2bOrderConnect: updateValidC2bOrder,
    setShowHubLocationModalConnect: setShowHubLocationModal,
    updateWishlistNoteConnect: updateWishlistNote,
    updateExtendedWarrantySelectionConnect: updateExtendedWarrantySelection,
    startPreApprovalOnFlyConnect: startPreApprovalOnFly,
    getValidQuotesInHouseFinanceConnect: getValidQuotesInHouseFinance,
    updateBasicHubspotConnect: updateBasicHubspot,
    getOrderDetailSuccessConnect: getOrderDetailSuccess,
    setTestDriveVariantConnect: setTestDriveVariant,
    getInhouseEligibilityConnect: getInhouseEligibility,
    getInhousePreApprovalLoanDetailsConnect: getInhousePreApprovalLoanDetails
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarDetailsCardRevamp));
